import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const FeatureView = () => {
  const { id } = useParams();
  const [feature, setFeature] = useState(null);
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/features/${id}`)
      .then((res) => setFeature(res.data))
      .catch(() => setFeature(null));
  }, [id]);

  if (!feature) return <div className="container mt-4">{getText("LOADING")}</div>;

  return (
    <div className="container mt-4 card p-4">
      <h4 className="fw-bold mb-3"> {getText("FEATURE_DETAIL_TITLE")}</h4>

      <div className="mb-3">
        <strong>{getText("TITLE_LABEL")}:</strong> {feature.title}
      </div>

      <div className="mb-3">
        <strong>{getText("REQUIRED_LABEL")}:</strong>{" "}
        {feature.is_required ? (
          <span className="badge bg-success">{getText("YES_LABEL")}</span>
        ) : (
          <span className="badge bg-secondary">   {getText("NO_LABEL")}</span>
        )}
      </div>

      <div className="mb-3">
        <strong>{getText("MULTIPLE_SELECTION_LABEL")}:</strong>{" "}
        {feature.is_multiple ? (
          <span className="badge bg-success">{getText("YES_LABEL")}</span>
        ) : (
          <span className="badge bg-secondary">{getText("NO_LABEL")}</span>
        )}
      </div>

      <div className="mb-3">
        <strong>{getText("INCLUDED_CATEGORIES_LABEL")}:</strong>
        <br />
        {feature.category_ids && feature.category_ids.length > 0 ? (
          feature.category_ids.map((cid) => (
            <span key={cid} className="badge bg-info me-2">
              {feature.category_names[cid]}
            </span>
          ))
        ) : (
          <span className="badge bg-secondary"> {getText("NO_CATEGORY_LABEL")}</span>
        )}
      </div>

      <div className="mb-3">
        <strong>{getText("VALUES_LABEL")}:</strong>
        <ul className="mt-2">
          {feature.values.length > 0 ? (
            feature.values.map((v) => (
              <li key={v.id}>
                {v.value}
                {v.status && (
                  <span className="badge bg-success ms-2">{getText("STATUS_ACTIVE")}</span>
                )}
              </li>
            ))
          ) : (
            <li>{getText("NO_VALUE_LABEL")}</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default FeatureView;
